<div
  class="rounded-t-2xl p-6 text-center text-3xl font-medium"
  [style.background-color]="getBackgroundColor()"
  [style.border-left-width]="ticketStyle.frame.borderWidth"
  [style.border-right-width]="ticketStyle.frame.borderWidth"
  [style.border-top-width]="ticketStyle.frame.borderWidth"
  [style.border-bottom-width]="ticketStyle.frame.borderWidth"
  [style.border-color]="corporateDesignService.primaryBorderColor()"
  [style.color]="corporateDesignService.fontColor()"
  [style.border-top-left-radius]="corporateDesignService.borderRadius()"
  [style.border-top-right-radius]="corporateDesignService.borderRadius()"
  [style.border-bottom-left-radius]="0"
  [style.border-bottom-right-radius]="0">
  {{
    textStore.texts()
      | filterTexts: relationType() : EEntityType.shoppingCart
      | language
  }}
</div>
